import { gql } from "@apollo/client";

export const AdressFragment = gql`
  fragment AdressFragment on Address {
    country
    city
    region
    address
    additional_address
    location {
      latitude
      longitude
    }
    place_id
  }
`;

export const StopFragment = gql`
  fragment StopFragment on Stop {
    refTemplateStop
    createdAt
    libelle
    action
    isDisabled
    status
    axe {
      name
    }
    address {
      place_id
      region
      address
      place_id
      location {
        latitude
        longitude
      }
    }
    items {
      product {
        name
        reference
        parcelUid
        parcelId
      }
      _id
      description
      quantity
      counter
    }
    hub {
      _id
      name
      location {
        ...AdressFragment
      }
    }
  }
  ${AdressFragment}
`;

export const AxeFragment = gql`
  fragment AxeFragment on Axe {
    refTemplateAxe
    name
    type
    stops {
      ...StopFragment
    }
    tasks {
      axe
      _id
      type
      runsheetId
      stops {
        ...StopFragment
      }
    }
    price
    discount
    vehicles {
      vehicleType
      numberOfVehicule
    }
    reccurenceType
    slotStart
    slotEnd
    reccurenceOptions {
      each
      days
      value
    }
  }
  ${AdressFragment}
  ${StopFragment}
`;

export const TemplateAxeFragment = gql`
  fragment TemplateAxeFragment on TemplateAxe {
    _id
    name
    templateStops {
      _id
      action
      isDisabled
      hubId
      pickupIds
      address {
        address
        place_id
      }
    }
    price
    discount
    vehicles {
      vehicleType
      numberOfVehicule
    }
    reccurenceType
    slotStart
    slotEnd
    reccurenceOptions {
      each
      days
      value
    }
  }
`;
